import { render, staticRenderFns } from "./UpdateSliderBanner.vue?vue&type=template&id=e6f8ff54"
import script from "./UpdateSliderBanner.vue?vue&type=script&lang=js"
export * from "./UpdateSliderBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports